/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_HighlightInputs */

const en_story_highlight = /** @type {(inputs: Story_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highlight`)
};

const es_story_highlight = /** @type {(inputs: Story_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destacado`)
};

const fr_story_highlight = /** @type {(inputs: Story_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps fort`)
};

const de_story_highlight = /** @type {(inputs: Story_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highlight`)
};

const id_story_highlight = /** @type {(inputs: Story_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorotan`)
};

/** @type {(inputs: Story_HighlightInputs) => LocalizedString} */
const ja_story_highlight = en_story_highlight;

/** @type {(inputs: Story_HighlightInputs) => LocalizedString} */
const zh_story_highlight = en_story_highlight;

/** @type {(inputs: Story_HighlightInputs) => LocalizedString} */
const ar_story_highlight = en_story_highlight;

/** @type {(inputs: Story_HighlightInputs) => LocalizedString} */
const it_story_highlight = en_story_highlight;

/** @type {(inputs: Story_HighlightInputs) => LocalizedString} */
const ru_story_highlight = en_story_highlight;

/** @type {(inputs: Story_HighlightInputs) => LocalizedString} */
const pt_story_highlight = en_story_highlight;

/** @type {(inputs: Story_HighlightInputs) => LocalizedString} */
const ko_story_highlight = en_story_highlight;

/**
* | output |
* | --- |
* | "Highlight" |
*
* @param {Story_HighlightInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_highlight = /** @type {((inputs?: Story_HighlightInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_HighlightInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_highlight(inputs)
	if (locale === "es") return es_story_highlight(inputs)
	if (locale === "fr") return fr_story_highlight(inputs)
	if (locale === "de") return de_story_highlight(inputs)
	if (locale === "ja") return ja_story_highlight(inputs)
	if (locale === "zh") return zh_story_highlight(inputs)
	if (locale === "ar") return ar_story_highlight(inputs)
	if (locale === "id") return id_story_highlight(inputs)
	if (locale === "it") return it_story_highlight(inputs)
	if (locale === "ru") return ru_story_highlight(inputs)
	if (locale === "pt") return pt_story_highlight(inputs)
	return ko_story_highlight(inputs)
});